module.exports = __webpack_public_path__ + "img/activity9.9ff717ce.png";